import { tenantAwareApiWrapper, withOrchestratorClient } from './portal-http';
import { commentsClient } from '@terra/shared-rest-clients-comments';
import type { CommentsContract } from '@terra/shared-contracts-comments';

export const portalCommentsApi = {
  getComments: (
    entityType:
      | 'APPLICATION'
      | 'ASSET'
      | 'FINDING'
      | 'SIGNAL'
      | 'EXECUTION_STATE'
      | 'ENDPOINT'
      | 'WEBPAGE',
    entityId: string,
  ) =>
    tenantAwareApiWrapper<typeof CommentsContract.getComments>({
      endpointFn: (headers) =>
        commentsClient.getComments({
          query: { entityType, entityId },
          ...withOrchestratorClient(headers),
        }),
    }),

  createComment: (body: {
    entityType:
      | 'APPLICATION'
      | 'ASSET'
      | 'FINDING'
      | 'SIGNAL'
      | 'EXECUTION_STATE'
      | 'ENDPOINT'
      | 'WEBPAGE';
    entityId: string;
    content: string;
    parentCommentId?: string | null;
  }) =>
    tenantAwareApiWrapper<typeof CommentsContract.createComment>({
      endpointFn: (headers) =>
        commentsClient.createComment({
          body: {
            ...body,
            parentCommentId: body.parentCommentId ?? null,
          },
          ...withOrchestratorClient(headers),
        }),
    }),

  updateComment: (commentId: string, body: { content?: string }) =>
    tenantAwareApiWrapper<typeof CommentsContract.updateComment>({
      endpointFn: (headers) =>
        commentsClient.updateComment({
          params: { commentId },
          body,
          ...withOrchestratorClient(headers),
        }),
    }),

  deleteComment: (commentId: string) =>
    tenantAwareApiWrapper<typeof CommentsContract.deleteComment>({
      endpointFn: (headers) =>
        commentsClient.deleteComment({
          params: { commentId },
          ...withOrchestratorClient(headers),
        }),
    }),

  // Application Guardrails endpoints
};
